import { AccountTypes } from '../components/changeUser/accountTypes.enum';

export const getRouteByAccountType = (accountType: AccountTypes) => {
  switch (accountType) {
    case AccountTypes.Guardian:
      return 'guardian';
    case AccountTypes.Org:
      return 'org';
    case AccountTypes.Clinic:
      return 'clinic';
    default:
      throw new Error('no account of that type exists');
  }
};
